export class GroupConst {
  static displayColumns = () => {
    return [
      {
        title: 'Tên bộ phận',
        key: 'name',
        display: true,
        allowSort: false,
        classes: '',
      },
    ];
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/expert/group/group.const.ts